import { render, staticRenderFns } from "./getInvoice.vue?vue&type=template&id=68193021&"
import script from "./getInvoice.vue?vue&type=script&lang=js&"
export * from "./getInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports